import TSPSDK from 'tsp-sdk';

const MODULE_NAME = 'career';

const translator = new TSPSDK({
  name: 'microsite' // [required] SDK实例名称，方便识别
});

// export const $t = (key) => translator.$t(key);
// 解决清空的key
export const $t = (key, options) => {
  if (/^\/tech|^\/codeleague|^\/sealabs|^\/succ|^\/nsgscholarship|^\/productdesign|/.test(window.location.pathname) || Number(process.env.REACT_APP_NO_FILTER_TRANSIFY)) {
    return translator.$t(key, options);
  }

  // $t函数会对没配置value的key返回key本身，需求需要对没有value的key展示为空
  const srcValue = translator.getTranslationByKey(key); // transify实际配置的值
  if (srcValue) {
    return translator.$t(key, options);
  } else {
    return srcValue;
  }
};

// 优先使用collection来加载transify资源
export function createTranslator(config = {}, resourceId = 4510, collectionId) {
  let baseModules;
  if (collectionId) {
    baseModules = [
      {
        name: MODULE_NAME, // [required] 模块名称
        collections: [collectionId] // [optional] 相关的resource id列表
      }
    ]
  } else {
    baseModules = [
      {
        name: MODULE_NAME, // [required] 模块名称
        resources: [resourceId] // [optional] 相关的resource id列表
      }
    ]
  }
  return translator.create({
    locale: 'en', // [optional] 当前语言类型，默认en
    timeout: 3000, // [optional] 从tsp api获取翻译的超时时间毫秒数，默认3000
    isMainland: true, // [optional] 用户判断cdn的地址，默认会根据host来判断
    baseModules,
    env: process.env.REACT_APP_ENV === 'live' ? 'live' : 'test',
    ...config
  })
}

export default translator;
